const CheckoutForm = require('./form.js');
const CheckoutSteps = require('./steps.js');
const CheckoutOverview = require('./overview.js');
// require('./account.js')
const CheckoutCoupons = require('./coupons.js');

class Checkout {
  constructor() {
    this.form = new CheckoutForm();

    // TODO: Don't skip validation in production!
    // this.form.skipValidation = true;

    this.coupons = new CheckoutCoupons();
    this.steps = new CheckoutSteps();

    jQuery('.mad-checkout').on(
      'click', 
      '.mad-checkout-order-review .mad-checkout-order-review__item-remove', 
      this.removeFromCart);

    jQuery('.mad-checkout-steps__button.previous').click(function (e) {
      this.steps.previous();
      this.scrollToCheckoutTop();
    }.bind(this));

    jQuery('.mad-checkout-steps__button.next').click(function (e) {
      if (this.steps.validateCurrentStep()) {
        this.steps.next();
        this.scrollToCheckoutTop();
      } else {
        this.scrollToFirstInvalidInput();
      }
    }.bind(this));

    // this.coupons = new CheckoutCoupons();

    this.overview = new CheckoutOverview(this.steps);

    jQuery( document.body ).trigger( 'updated_checkout');

    // --- Sticky Checkout Overview (replaces ScrollTrigger pin) ---
    window.$dependencyManager.addDependenciesCallback(['gsap', 'scrollTrigger'], () => {
      const $wrapper   = jQuery('.mad-checkout-order-review__wrapper');
      const $container = jQuery('.mad-checkout-order-review__container');
      if (!$wrapper.length || !$container.length) return;

      // State with frozen baselines to avoid shifting when mega menu opens
      const state = {
        baseline: { adminBar: 0, navbar: 0 },
      };

      const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

      const captureBaselines = () => {
        // Freeze heights ONLY at init and on actual window resizes
        const $adminBar = jQuery('#wpadminbar');
        const $navbar   = jQuery('.mad-navbar__section');
        state.baseline.adminBar = $adminBar.length ? ($adminBar.outerHeight() || 0) : 0;
        state.baseline.navbar   = $navbar.length ? ($navbar.outerHeight()   || 0) : 0;
      };

      const computeTopOffset = () => {
        // Original code used base 20 + adminbar + navbar
        return 20 + (state.baseline.adminBar || 0) + (state.baseline.navbar || 0);
      };

      const fitsViewport = () => {
        const offset = computeTopOffset();
        const vh = jQuery(window).height();
        const ch = $container.outerHeight() || 0;
        return ch <= (vh - offset);
      };

      const applySticky = () => {
        const topVal = computeTopOffset();
        $container.css({
          position: 'sticky',
          top: `${topVal}px`,
          zIndex: 2 // ensure it stays above backgrounds
        });
      };

      const removeSticky = () => {
        $container.css({
          position: '',
          top: '',
          zIndex: ''
        });
      };

      const refreshSticky = () => {
        if (!isDesktop()) {
          removeSticky();
          return;
        }
        if (fitsViewport()) {
          applySticky();
        } else {
          removeSticky();
        }
      };

      // Init: capture baseline and set initial sticky state
      captureBaselines();
      refreshSticky();

      // Recalculate on real resizes / orientation changes
      const debounce = (fn, wait) => {
        let t; return function () {
          clearTimeout(t); t = setTimeout(() => fn.apply(this, arguments), wait);
        };
      };

      const handleResize = () => {
        captureBaselines();   // recompute baselines ONLY on real window resize
        refreshSticky();
      };

      jQuery(window).on('resize orientationchange', debounce(handleResize, 150));

      // React to WooCommerce updates that can change the review height/content
      jQuery(document.body).on(
        'updated_checkout updated_cart_totals applied_coupon removed_coupon wc_fragments_loaded wc_fragments_refreshed',
        debounce(refreshSticky, 50)
      );

      // Also observe live size changes of the container and wrapper (e.g., totals change)
      if ('ResizeObserver' in window) {
        try {
          const ro = new ResizeObserver(() => refreshSticky());
          ro.observe($container.get(0));
          ro.observe($wrapper.get(0));
        } catch (e) { /* ignore */ }
      }

      // IMPORTANT: we do NOT observe navbar/adminbar here
      // to avoid changing top when mega menu opens.
    });
  }

  scrollToCheckoutTop() {
    // Calculate the offset position of .mad-checkout-form__container
    var formContainerOffset = jQuery('.mad-checkout').offset().top;

    // Animate the scroll to .mad-checkout-form__container
    jQuery('html, body').animate({
      scrollTop: formContainerOffset - 120
    }, 300);
  }

  scrollToFirstInvalidInput() {

    var firstInvalidInput = jQuery('.woocommerce-invalid').first();
    // Calculate the offset position of .mad-checkout-form__con tainer
    var inputOffset = firstInvalidInput.offset();

    if (inputOffset) {
      // Animate the scroll to .mad-checkout-form__container
      jQuery('html, body').animate({
        scrollTop: inputOffset.top - 120
      }, 300);
    } else {
      // console.log('Could not scroll to element!', firstInvalidInput);
    }
  }

  
  removeFromCart(e) {

    e.preventDefault();

    var button = jQuery(e.target).closest('.mad-checkout-order-review__item-remove > a')
    var item = button.closest('.mad-checkout-order-review__item')
    
    window.$madUtil.blockElement('.mad-checkout-order-review__container', {icon: {size: 'large'}})


    jQuery.ajax({
      type: 'POST',
      url: wc_checkout_params.wc_ajax_url.toString().replace('%%endpoint%%', 'remove_from_cart'),
      data: {
        cart_item_key: button.data('cart_item_key')
      },
      success: function (response) {
        if ( ! response || ! response.fragments ) {
					window.location = button.attr( 'href' );
					return;
				}

        window.$madUtil.updateFragments(response.fragments);
        window.$madUtil.unblockElement('.mad-checkout-order-review__container')
      },
			error: function(response) {
        console.log('Error:', response)
				// window.location = button.attr( 'href' );
				// return;
        window.$madUtil.unblockElement('.mad-checkout-order-review__container')
			},
      dataType: 'json'
    });
  }
}

jQuery(document).ready(() => {
  if (!jQuery('.mad-checkout__container').length) return;

  require('./shipping.js')
  require('./payment.js')
  
  var checkout = new Checkout();
  window.$checkout = checkout;
})
